import React from 'react';
import { useIntl } from 'react-intl';
import { Button, DialogWithCloseButton, InlineTextButton, TypographyWrapper } from '..';
import css from './DeletePaymentMethodModal.module.css';

interface DeletePaymentMethodModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDeleteCard?: () => void;
  deletePaymentMethodInProgress?: boolean;
  last4Digits?: string;
}

const DeletePaymentMethodModal: React.FC<DeletePaymentMethodModalProps> = ({
  isOpen,
  onClose,
  onDeleteCard,
  deletePaymentMethodInProgress = false,
  last4Digits,
}) => {
  const intl = useIntl();

  const removeCardModalTitle = 'Remove card?';
  const cancel = intl.formatMessage({ id: 'SavedCardDetails.cancel' });
  const removeCard = intl.formatMessage({ id: 'SavedCardDetails.removeCard' });

  return (
    <DialogWithCloseButton
      open={isOpen}
      allowFullScreen={false}
      onClose={onClose}
      fullWidth
      titleText={removeCardModalTitle}
      maxWidth="sm"
    >
      <div className={css.modalContentWrapper}>
        <div className={css.modalContentBody}>
          <TypographyWrapper variant="body1">
            The payment card ••••&nbsp;••••&nbsp;••••&nbsp;
            <TypographyWrapper variant="body1" isDynamicValue component="span">
              {last4Digits}
            </TypographyWrapper>{' '}
            will be removed from your account.
          </TypographyWrapper>
        </div>

        <div className={css.modalButtonsWrapper}>
          <InlineTextButton type="button" onClick={onClose} className={css.cancelButton}>
            <TypographyWrapper variant="body1">{cancel}</TypographyWrapper>
          </InlineTextButton>
          <Button
            onClick={onDeleteCard}
            inProgress={deletePaymentMethodInProgress}
            className={css.deleteButton}
          >
            {removeCard}
          </Button>
        </div>
      </div>
    </DialogWithCloseButton>
  );
};

export default DeletePaymentMethodModal;
